// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2044 ? "891cff7f" : chunkId) + "." + {"2044":"ce86a83bb4601af6","6505":"fd67c458af033c82","8690":"ebe8d6f0ac20291e"}[chunkId] + ".js";
};